import { render, staticRenderFns } from "./table-tertiary.vue?vue&type=template&id=3f687da2&scoped=true"
import script from "./table-tertiary.vue?vue&type=script&lang=js"
export * from "./table-tertiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f687da2",
  null
  
)

export default component.exports